import { createApp } from 'vue';
import PdfToPngConverter from '@/Components/PdfToPngConverter.vue';
import '@styles/app.css';

createApp(PdfToPngConverter).mount('#pdf-to-png-converter');
